const map = {
	"./hero.jpg": 480,
	"./image1.jpg": 928,
	"./image10.jpg": 610,
	"./image11.jpg": 895,
	"./image12.jpg": 280,
	"./image13.jpg": 509,
	"./image14.jpg": 46,
	"./image2.jpg": 855,
	"./image3.jpg": 690,
	"./image4.jpg": 153,
	"./image5.jpg": 892,
	"./image6.jpg": 515,
	"./image7.jpg": 558,
	"./image8.jpg": 301,
	"./image9.jpg": 736,
	"./image_circleofnurses.jpg": 651,
	"./image_nursepose.jpg": 344,
	"./image_nurseworking.jpg": 326,
	"./image_scope.jpg": 404,
	"./place1.jpg": 870,
	"./training.jpg": 934
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 535;